import { Component } from 'react';
import { ArrowLeft, AlertTriangle, RotateCcw } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#060608] flex items-center justify-center">
          <div className="max-w-md mx-auto px-6 text-center">
            <AlertTriangle className="w-12 h-12 text-[#FF4500] mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Something went wrong
            </h2>
            <p className="text-sm text-[#8A8A93] mb-4">
              {this.state.error?.message || 'An unexpected error occurred'}
            </p>
            {this.state.errorInfo && (
              <details className="text-left mb-4">
                <summary className="text-xs text-[#55555C] cursor-pointer hover:text-[#8A8A93]">
                  Error details
                </summary>
                <pre className="mt-2 text-[10px] text-[#55555C] bg-[#0a0a0e] p-3 rounded-lg overflow-auto max-h-40 border border-white/[0.06]">
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => window.history.back()}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm text-[#8A8A93] hover:text-white hover:bg-white/5 border border-white/[0.06] transition-colors"
              >
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
              <button
                onClick={() => window.location.reload()}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-[#FF4500] hover:bg-[#FF5722] text-white transition-colors"
              >
                <RotateCcw className="w-4 h-4" /> Reload
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
